import React, { useState, useEffect } from 'react';
import api from "../../../api/api";
import ParentPanel from '../panel/ParentPanel';
import '../styles/PayFees.css';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { jwtDecode } from "jwt-decode";

const PayFees = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [feesData, setFeesData] = useState([]);        // Outstanding
  const [pastFeesData, setPastFeesData] = useState([]); // Paid history
  const cardColors = ['#5c3dc4', '#ff6b6b', '#ffa500', '#4caf50', '#00bfff'];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("⚠️ No JWT token found. Please login again.");
      return;
    }

    // ✅ fetch from /my-fees
    api.get("/api/fees/my-fees", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        console.log("Fetched fees:", res.data);


const outstanding = res.data; 
setFeesData(outstanding);

        const grouped = {};
        res.data
          .filter(f => f.isPaid)
          .forEach(fee => {
            const year = new Date(fee.due_date).getFullYear();
            if (!grouped[year]) grouped[year] = [];
            grouped[year].push({ type: fee.fee_type, amount: fee.amount });
          });

        const formatted = Object.keys(grouped).map(y => ({
          year: y,
          details: grouped[y],
        }));
        setPastFeesData(formatted);
      })
      .catch(err => console.error("❌ Error fetching fees:", err));
  }, []);

  // Calculate totals per year
  const yearCards = pastFeesData.map((y) => ({
    year: y.year,
    total: y.details.reduce((sum, fee) => sum + fee.amount, 0),
  }));

// Prepare chart data directly from fetched fees
const chartData = feesData.length > 0
  ? feesData.map(f => ({
      name: f.fee_type || f.feeType || "Unknown Fee",
      value: Number(f.amount) || 0
    }))
  : [{ name: "No Outstanding Fees", value: 1 }];


  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`admin-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Top Bar */}
        <div className="dashboard-topbar">
          <span className="date-time">TODAY IS {new Date().toLocaleString()}</span>
          <span className="school-name">Semigon Learning</span>
        </div>

        {/* Outstanding Fees */}
        <h3 className="dashboard-title">Outstanding Fees</h3>
        <div className="quick-links">
          {feesData.map((fee, index) => (
            <div
              className="quick-link-card fees"
              key={fee.id}
              style={{ backgroundColor: cardColors[index % cardColors.length] }}
            >
              <div className="ql-left">
                <div className="ql-count">₹{fee.amount}</div>
                <div className="ql-label">{fee.fee_type}</div>
              </div>
              <button className="pay-now-btn">Pay Now</button>
            </div>
          ))}
          {feesData.length === 0 && (
            <p style={{ marginTop: "10px", color: "#777" }}>✅ No outstanding fees</p>
          )}
        </div>

        {/* Pie Chart */}
        <div className="accounts-overview-chart">
          <h3 className="chart-title">Fees Distribution</h3>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
             <Pie
  data={chartData}
  dataKey="value"
  nameKey="name"
  cx="50%"
  cy="50%"
  innerRadius={80}
  outerRadius={150}
  paddingAngle={5}
  label={({ name, value }) => `${name}: ₹${value}` }
>
  {chartData.map((f, index) => (
    <Cell key={`cell-${index}`} fill={cardColors[index % cardColors.length]} />
  ))}
</Pie>

              <Tooltip formatter={(value) => `₹ ${value}`} />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Previous Fees Paid */}
        <h3 className="dashboard-title">Previous Fees Paid</h3>
        <div className="quick-links">
          {yearCards.map((yearCard, index) => (
            <div
              className="quick-link-card fees"
              key={index}
              style={{ backgroundColor: cardColors[index % cardColors.length] }}
              onClick={() => setSelectedYear(pastFeesData[index])}
            >
              <div className="ql-left">
                <div className="ql-count">₹{yearCard.total}</div>
                <div className="ql-label">{yearCard.year}</div>
              </div>
              <button className="pay-now-btn">View Details</button>
            </div>
          ))}
          {yearCards.length === 0 && (
            <p style={{ marginTop: "10px", color: "#777" }}>ℹ️ No payment history yet</p>
          )}
        </div>

        {/* Year Details Modal */}
        {selectedYear && (
          <div className="join-modal-overlay" onClick={() => setSelectedYear(null)}>
            <div className="join-modal" onClick={(e) => e.stopPropagation()}>
              <h2>Payment Details - {selectedYear.year}</h2>
              <ul style={{ textAlign: 'left', marginBottom: '20px' }}>
                {selectedYear.details.map((fee, idx) => (
                  <li key={idx}>
                    <strong>{fee.type}:</strong> ₹{fee.amount}
                  </li>
                ))}
              </ul>
              <button className="pay-now-btn">Download PDF</button>
              <br />
              <button
                className="pay-now-btn"
                style={{ marginTop: '10px', background: '#999' }}
                onClick={() => setSelectedYear(null)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PayFees;
